<template>
  <main
    :class="[
      'submit-btn-wrap',
      'space-between',
      isTurbo ? 'gameTurbo' : '',
      browser,
      isMobile ? '' : 'desktop',
    ]"
    ref="submitBtn"
  >
    <!-- 支付价格 -->
    <div :class="['price-container', region]">
      <div :key="`payPrice1${payPrice}`" :class="['pay-price', payPriceClass]">
        <span>{{ text.payPricePrefix }}</span> {{ formattedPrice }}
      </div>
      <div
        :key="`originalPrice1${originalPrice}`"
        class="original-price"
        v-if="!isMyWallet"
      >
        {{ text.originalPriceText }}:
        <money-display
          :number="Number(originalPrice)"
          :allowShowKcoin="false"
        />
      </div>
    </div>
    <!-- 确认按钮 -->
    <div class="submit-btn">
      <div
        :class="[
          'submitBtn',
          readyToSubmit ? '' : 'disabled',
          isTurbo ? 'gameTurbo' : '',
          isLoading ? 'btnLoading' : '',
        ]"
        @click="click"
        :style="readyToSubmit ? submitBtnStyle : null"
      >
        <span>{{ text.submitText }}</span>
      </div>
    </div>
  </main>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { priceFormat } from '@/utils/priceFormat'
  import MoneyDisplay from '@/components/MoneyDisplay'
  import { getBrowserType } from '@/utils/utils'

  export default {
    name: 'submit-btn',
    components: {
      MoneyDisplay,
    },
    props: {
      payPrice: {
        type: [String, Number],
        default: 0,
      },
      originalPrice: {
        type: [Number, String],
        default: 0,
      },
      readyToSubmit: {
        type: Boolean,
        default: false,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      closeRecharge: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        submitBtnStyle: {},
        isMyWallet: this.$route.name === 'myWallet',
      }
    },
    computed: {
      ...mapState([
        'currency',
        'region',
        'isTurbo',
        'isMobile',
        'selectedPaymentInfo',
        'createOrderState',
        'isChromeBrowser',
        'isMiuiBrowser',
        'isApp',
      ]),
      ...mapGetters(['displayTurbo', 'displayMobile']),
      browser() {
        return getBrowserType(this.isMiuiBrowser, this.isChromeBrowser)
      },
      text() {
        return {
          // originalPriceText: this.$t(`common.originalPriceText`),
          originalPriceText: this.$t(`game.equivalent_to`), // 相当于
          // 侧边栏：总计
          // 详情页：需要支付
          payPricePrefix: this.isMyWallet
            ? `${this.$t('common.payPricePrefix')}:`
            : this.$t('game.amount_to_be_paid'),
          submitText: this.$t(`order.continue_to_pay`),
        }
      },
      formattedPrice() {
        return priceFormat(this.payPrice, this.region)
      },
      payPriceClass() {
        const str = this.text.payPricePrefix + this.formattedPrice
        const strLen = str.length
        return strLen > 20 ? 'smaller-size' : strLen > 13 ? 'medium-size' : ''
      },
    },
    methods: {
      click() {
        if (this.isApp) {
          this.$emit('submit', this.closeRecharge)
        } else {
          this.$emit('submit')
        }
      },
    },
  }
</script>
<style scoped lang="scss" src="./submitBtn.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './submitBtn_pc.scss';
  }
</style>
